"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _es6Promise = require("es6-promise");

var _abstractClient = _interopRequireDefault(require("./abstract-client"));

var AjaxClient =
/*#__PURE__*/
function (_AbstractClient) {
  (0, _inherits2["default"])(AjaxClient, _AbstractClient);

  function AjaxClient() {
    (0, _classCallCheck2["default"])(this, AjaxClient);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(AjaxClient).apply(this, arguments));
  }

  (0, _createClass2["default"])(AjaxClient, [{
    key: "setToken",
    value: function setToken(token) {
      this.credentials.token = token;
    }
  }, {
    key: "createXhr",
    value: function createXhr() {
      return new XMLHttpRequest();
    }
  }, {
    key: "sendRequest",
    value: function sendRequest(method, url, params, overrides) {
      var _this = this;

      return new _es6Promise.Promise(function (resolve, reject) {
        var request = _this.createXhr();

        request.open(method, _this.apiBase + url, true);
        request.responseType = 'text';
        request.setRequestHeader(_this.getAuthorizationHeaderName(), "Token ".concat(_this.credentials.token));
        request.setRequestHeader('Content-Type', 'application/json');

        if (overrides && overrides.headers) {
          var mergedHeaders = (0, _objectSpread2["default"])({}, _this.headers, overrides.headers);
          Object.keys(mergedHeaders).forEach(function (key) {
            request.setRequestHeader(key, mergedHeaders[key]);
          });
        } else {
          Object.keys(_this.headers).forEach(function (key) {
            request.setRequestHeader(key, _this.headers[key]);
          });
        }

        request.onreadystatechange = function () {
          if (request.readyState === 4 && request.status !== 0) {
            var headers = (request.getAllResponseHeaders() || '').trim().split('\r\n').reduce(function (map, line) {
              var _line$split = line.split(':'),
                  _line$split2 = (0, _toArray2["default"])(_line$split),
                  field = _line$split2[0],
                  rest = _line$split2.slice(1);

              var fieldName = field.trim().toLowerCase();
              var priorValue = map[fieldName];
              map[fieldName] = (priorValue ? "".concat(priorValue, "\n") : '') + rest.join(':');
              return map;
            }, {});
            resolve({
              status: request.status,
              body: request.responseText || '',
              headers: headers
            });
          }
        };

        request.onerror = function (error) {
          return reject(error);
        };

        request.ontimeout = function () {
          return resolve({
            wasNetworkTimeout: true
          });
        };

        if (params) {
          request.send(JSON.stringify(params));
        } else {
          request.send();
        }
      });
    }
  }]);
  return AjaxClient;
}(_abstractClient["default"]);

exports["default"] = AjaxClient;